import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { PeopleQueries } from '@sales-app/graphql/queries/people.queries'
import { BookablePersonDuplicate } from '@sales-app/types/BookablePersonDuplicate'
import React, { FC, useCallback, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { BottomSheet, Table } from '@/components'
import { useToggle } from '@/hooks'
import { useGraphql } from '@/hooks/useGraphql'

import { DuplicateColumns } from '../PersonSummary.data'
import { DuplicateReview } from './DuplicateReview/DuplicateReview'

type Props = {
  bookablePerson: WorkspaceTab
}

export const DuplicatePersons: FC<Props> = ({ bookablePerson }) => {
  const [bookableDuplicate, setBookableDuplicate] = useState<BookablePersonDuplicate>()
  const { isShown, toggle } = useToggle()
  const navigate = useNavigate()
  const { data, refetch } = useGraphql<PeopleQueries.GET_BOOKABLE_PERSON_DUPLICATES.Response>(
    PeopleQueries.getBookablePersonDuplicates.name,
    PeopleQueries.getBookablePersonDuplicates(),
    {
      bookablePersonRecord: {
        bookablePersonId: bookablePerson.bookablePersonId,
        bookablePersonType: bookablePerson.bookablePersonType,
      },
    },
  )

  const { refetch: refetchBookableData } = useGraphql<PeopleQueries.GET_BOOKABLE_PERSON.Response>(
    PeopleQueries.getBookablePerson.name,
    PeopleQueries.getBookablePerson(),
    {
      bookablePersonRecord: {
        bookablePersonId: bookablePerson.bookablePersonId,
        bookablePersonType: bookablePerson.bookablePersonType,
      },
    },
  )

  const handleDuplicateMerge = useCallback(
    (duplicateReview: BookablePersonDuplicate) => {
      if (!isShown) {
        setBookableDuplicate(duplicateReview)
        toggle()
      }
    },
    [isShown, toggle],
  )

  const duplicateColumns = useMemo(() => {
    return DuplicateColumns(handleDuplicateMerge)
  }, [handleDuplicateMerge])

  const handleCloseModal = (path?: string) => {
    toggle()
    if (path) {
      navigate(path)
    }
  }

  const refetchData = () => {
    refetch()
    refetchBookableData()
  }

  const duplicatesTableData = data?.bookablePerson?.duplicatesForReview ? data?.bookablePerson?.duplicatesForReview : []
  return (
    <>
      {duplicatesTableData && duplicatesTableData.length > 0 && (
        <div className="mb-6 flex w-full flex-col">
          <div className="mb-4 flex items-center justify-between">
            <h3 className=" text-header-md">Potential Duplicates</h3>
          </div>
          <Table columns={duplicateColumns as any} data={duplicatesTableData} />
          <BottomSheet isVisible={isShown} mobileFullHeight={true} onClose={toggle}>
            {bookableDuplicate && (
              <DuplicateReview
                bookablePerson={bookablePerson}
                closeModal={handleCloseModal}
                duplicateReview={bookableDuplicate}
                refetch={refetchData}
              />
            )}
          </BottomSheet>
        </div>
      )}
    </>
  )
}
